import { render } from "./HomeFeatures.vue?vue&type=template&id=3e38aafd"
import script from "./HomeFeatures.vue?vue&type=script&lang=js"
export * from "./HomeFeatures.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__